import { render } from "./LanguageSwitch.vue?vue&type=template&id=a507781e&scoped=true&ts=true"
import script from "./LanguageSwitch.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitch.vue?vue&type=script&lang=ts"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=a507781e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a507781e"]])

export default __exports__